import { render, staticRenderFns } from "./ReviewTest.vue?vue&type=template&id=4a7508fe&scoped=true&"
import script from "./ReviewTest.vue?vue&type=script&lang=js&"
export * from "./ReviewTest.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTest.vue?vue&type=style&index=0&id=4a7508fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7508fe",
  null
  
)

export default component.exports